import React from "react";
import {
  useTable,
  useSortBy,
  usePagination,
  useGlobalFilter,
} from "react-table";
import { FaEdit, FaTrashAlt, FaWpforms } from "react-icons/fa";
import "./table.css";
import { TextField, InputAdornment } from "@mui/material";
import { FaSearch } from "react-icons/fa";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { TiArrowUnsorted } from "react-icons/ti";
import { FaSortDown, FaSortUp } from "react-icons/fa6";
import { GiProgression } from "react-icons/gi";
import { MdOutlineLockReset } from "react-icons/md";
import { MdDashboard } from "react-icons/md";

const GlobalFilter = ({ globalFilter, setGlobalFilter }) => {
  return (
    <div className="global">
    <TextField
      variant="outlined"
      placeholder="Filter..."
      value={globalFilter || ""}
      onChange={(e) => setGlobalFilter(e.target.value || undefined)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <FaSearch />
          </InputAdornment>
        ),
      }}    
    />
    </div>
  );
};

const TableOne = ({
  columns,
  data,
  handleDelete,
  handleEdit,
  handleProgress,
  isTaskProgress,
  handleDashboard,
  isDashboardProgress,
  isResetPassword,
  handleResetPassword,
  isEditAction,
  isDeleteAction,
  userRole, // Prop to determine role
}) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    state: { pageIndex, pageSize, globalFilter },
    nextPage,
    previousPage,
    setPageSize,
    setGlobalFilter,
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 5 },
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  // Hide Actions column only if userRole is "Manager"
  const hideActions = userRole?.toLowerCase() === "manager";
  return (
    <div>
      <div className="global-filter-container">
        <GlobalFilter
          globalFilter={globalFilter}
          setGlobalFilter={setGlobalFilter}
        />
      </div>
      <div className="table-container">
        <table {...getTableProps()} className="table">
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr
                {...headerGroup.getHeaderGroupProps()}
                className="table-header-row"
              >
                {headerGroup.headers.map((column) => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    className="table-header"
                  >
                    {column.render("Header")}
                    <span
                      style={{ position: "relative", left: "3px", top: "2px" }}
                    >
                      {column.isSorted ? (
                        column.isSortedDesc ? (
                          <FaSortDown />
                        ) : (
                          <FaSortUp />
                        )
                      ) : (
                        <TiArrowUnsorted />
                      )}
                    </span>
                  </th>
                ))}
                {!hideActions && <th className="table-header">Actions</th>}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {page.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()} className="table-row">
                  {row.cells.map((cell) => (
                    <td {...cell.getCellProps()} className="table-cell">
                      {cell.render("Cell")}
                    </td>
                  ))}
                  {!hideActions && (
                    <td className="table-cell">
                      <div className="tablebutton">
                      {isDashboardProgress && (
                          <button
                            className="btn-progress"
                            onClick={() => handleDashboard(row.original)}
                          >
                            <MdDashboard />
                          </button>
                        )}
                        {isTaskProgress && (
                          <button
                            className="btn-progress"
                            onClick={() => handleProgress(row.original)}
                          >
                            <GiProgression />
                          </button>
                        )}                        
                        {isResetPassword && (
                          <button
                            className="btn-resetpassword"
                            onClick={() => handleResetPassword(row.original)}
                          >
                            <MdOutlineLockReset />
                          </button>
                        )}
                        {isEditAction && (
                          <button
                            className="btn-edit"
                            onClick={() => handleEdit(row.original)}
                          >
                            <FaEdit />
                          </button>
                        )}
                        {userRole !== "manager" &&
                          userRole !== "Team Leader" &&
                          isDeleteAction && (
                            <button
                              className="btn-delete"
                              onClick={() => handleDelete(row.original)}
                            >
                              <FaTrashAlt />
                            </button>
                          )}
                      </div>
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
<div className="pagination-main">
        <div className="pagination-container">
        Rows Per Page: <select
    className="pagination-dropdown"
    value={pageSize}
    onChange={(e) => setPageSize(Number(e.target.value))}
  >
    {[5, 10, 15, 20, 25, 30, 35, 40, 45, 50].map((size) => (
      <option key={size} value={size}>{size}</option>
    ))}
  </select>
        </div>
        <div className="pagination">
          <button
            onClick={() => previousPage()}
            disabled={!canPreviousPage}
            className="pagination-button"
          >
            <FaArrowLeft />
          </button>
          <span>
            Page{" "}
            <strong>
              {pageIndex + 1} of {pageOptions.length}
            </strong>
          </span>
          <button
            onClick={() => nextPage()}
            disabled={!canNextPage}
            className="pagination-button"
          >
            <FaArrowRight />
          </button>
            </div>
            </div>
    </div>
  );
};
export default TableOne;

